import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ContactUsComponent} from './contact-us.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import {MatButtonModule, MatFormFieldModule} from '@angular/material';
import {CaptchaModule} from '../../common/captcha/captcha.module';

@NgModule({
    imports: [
        FormsModule,
        CommonModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        MatButtonModule,
        ReactiveFormsModule,
        MatProgressSpinnerModule,
        CaptchaModule
    ],
    declarations: [ContactUsComponent],
    exports: [ContactUsComponent]
})
export class ContactUsModule {
}
